<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
  background: radial-gradient(circle at top left, #e6f8f0 0, #f5fbff 35%, #eef5ff 70%, #f9fbff 100%);
  color: #333;
}

#app {
  min-height: 100vh;
}

/* 品牌主色：参考现代绿色农业+科技感 */
:root {
  --kh-primary: #17b676;
  --kh-primary-dark: #0f8f59;
  --kh-primary-light: #e6f8f0;
  --kh-accent: #0f9bd7;
}

/* 全局 Element 主按钮/主色覆盖 */
.el-button--primary,
.el-button--primary:focus,
.el-button--primary:hover {
  background-image: linear-gradient(135deg, var(--kh-primary) 0%, var(--kh-accent) 100%);
  border-color: var(--kh-primary);
}

.el-button--primary.is-plain {
  color: var(--kh-primary);
  background-color: #fff;
  border-color: var(--kh-primary);
}

.el-button--primary.is-plain:hover,
.el-button--primary.is-plain:focus {
  color: #fff;
  background-image: linear-gradient(135deg, var(--kh-primary) 0%, var(--kh-accent) 100%);
}

.el-link.el-link--primary {
  color: var(--kh-primary);
}

.el-pagination.is-background .el-pager li.active {
  background-color: var(--kh-primary);
}

.el-tag.el-tag--success,
.el-badge__content.is-fixed {
  background-color: var(--kh-primary);
  border-color: var(--kh-primary);
}
/* 角色等 success 标签文字强制白色，避免正式环境对比度不足导致看不清 */
.el-tag.el-tag--success {
  color: #fff !important;
}
.el-tag.el-tag--success .el-icon-close {
  color: #fff !important;
}
.el-tag.el-tag--success .el-icon-close:hover {
  background-color: rgba(255, 255, 255, 0.3);
  color: #fff !important;
}

/* 移动端整体字体与触控区域放大 */
@media (max-width: 768px) {
  body {
    font-size: 15px;
  }

  .el-form-item__label {
    font-size: 14px;
  }

  .el-input__inner,
  .el-textarea__inner,
  .el-select .el-input__inner {
    font-size: 14px;
    height: 38px;
  }

  .el-button {
    font-size: 14px;
    padding: 9px 14px;
  }

  .el-table th > .cell,
  .el-table .cell {
    font-size: 14px;
  }

  .el-menu-item {
    font-size: 15px;
    height: 46px;
    line-height: 46px;
  }
}

/* 列表行 hover：整行统一主题浅绿背景，简洁炫酷 */
.el-table .el-table__body tr:hover > td {
  background-color: rgba(23, 182, 118, 0.12) !important;
  transition: background-color 0.2s ease;
}
.el-table .el-table__body tr:hover > td.el-table__expanded-cell {
  background-color: rgba(23, 182, 118, 0.08) !important;
}

/* ========= 全局 Loading 炫酷样式（去掉全屏模糊，仅保留中心动画） ========= */
.kh-global-loading.el-loading-mask {
  background: transparent !important;
}

.kh-global-loading .el-loading-spinner {
  top: 50%;
  margin-top: -34px;
}

/* ElementUI 会把 spinner 当成 class 写到 <i> 上，这里自定义一个更酷的动画 */
.kh-loading-spinner {
  width: 56px;
  height: 56px;
  display: inline-block;
  position: relative;
}

.kh-loading-spinner::before,
.kh-loading-spinner::after {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border: 3px solid rgba(255, 255, 255, 0.25);
  border-top-color: rgba(23, 182, 118, 0.95);
  border-right-color: rgba(15, 155, 215, 0.95);
  animation: khSpin 0.9s linear infinite;
  box-shadow: 0 0 0 6px rgba(255, 255, 255, 0.06);
}

.kh-loading-spinner::after {
  inset: 10px;
  border-width: 3px;
  border-top-color: rgba(15, 155, 215, 0.95);
  border-right-color: rgba(23, 182, 118, 0.95);
  animation-duration: 1.2s;
  opacity: 0.95;
}

@keyframes khSpin {
  to {
    transform: rotate(360deg);
  }
}

.kh-global-loading .el-loading-text {
  margin-top: 14px;
  font-size: 13px;
  letter-spacing: 1px;
  color: rgba(255, 255, 255, 0.95);
  text-shadow: 0 6px 16px rgba(0, 0, 0, 0.35);
}
</style>